/* Black Friday Bid & Buy 2026, aan de bezoekerskant.

   1. Einde. Alles van de actie draagt data-bf-tot="<epoch einde>". Shopify
      cachet pagina's een paar minuten; staat er na het einde nog een oude
      pagina, dan haalt dit script de actie-onderdelen weg. Bij een
      testdatum (data-bf-test) niet: dan bepaalt de testklok het.
   2. Verkoper. snippets/bf-verkoper zet alle verkopers in de HTML. Per
      bezoek één keuze, voor alle plekken dezelfde, in dezelfde opslag als de
      Ansprechpartner op de PDP (sessionStorage solza-bid-contact), zodat de
      naam in het zwarte blok en in de Bid & Buy-band gelijk is.
   3. Filterchips op de actiepagina: knoppen met aria-pressed, items met
      data-bf-kenmerken. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- einde */
  function ruimOp() {
    var nu = Date.now() / 1000;
    document.querySelectorAll('[data-bf-tot]').forEach(function (el) {
      if (el.hasAttribute('data-bf-test')) return;
      var tot = parseInt(el.getAttribute('data-bf-tot'), 10);
      if (tot > 0 && nu >= tot) el.remove();
    });
    // Wat tijdens de actie verborgen is (de gewone mededelingenbalk), komt na
    // het einde meteen terug, ook op een gecachete pagina.
    document.querySelectorAll('[data-bf-na]').forEach(function (el) {
      if (el.hasAttribute('data-bf-test')) return;
      var na = parseInt(el.getAttribute('data-bf-na'), 10);
      if (na > 0 && nu >= na) el.style.display = '';
    });
  }

  /* -------------------------------------------------------------- verkoper */
  var OPSLAG = 'solza-bid-contact';

  function lees(sleutel) {
    try {
      return window.sessionStorage.getItem(sleutel);
    } catch (_fout) {
      return null;
    }
  }

  function bewaar(sleutel, waarde) {
    try {
      window.sessionStorage.setItem(sleutel, waarde);
    } catch (_fout) {
      /* geen opslag: volgende pagina kiest opnieuw */
    }
  }

  function kiesVerkoper() {
    var groepen = document.querySelectorAll('[data-bf-verkoper]');
    if (!groepen.length) return;
    var keuzes = groepen[0].querySelectorAll('[data-bf-verkoper-keuze]');
    if (!keuzes.length) return;

    var sleutels = Array.prototype.map.call(keuzes, function (k) {
      return k.getAttribute('data-bf-verkoper-keuze');
    });
    var gekozen = lees(OPSLAG);
    if (sleutels.indexOf(gekozen) === -1) {
      gekozen = sleutels[Math.floor(Math.random() * sleutels.length)];
      bewaar(OPSLAG, gekozen);
      bewaar(OPSLAG + '-naam', keuzes[sleutels.indexOf(gekozen)].getAttribute('data-naam'));
    }

    groepen.forEach(function (groep) {
      groep.querySelectorAll('[data-bf-verkoper-keuze]').forEach(function (el) {
        el.hidden = el.getAttribute('data-bf-verkoper-keuze') !== gekozen;
      });
    });
  }

  /* ----------------------------------------------------------------- chips */
  function chips() {
    document.querySelectorAll('[data-bf-chips]').forEach(function (balk) {
      var raster = document.getElementById(balk.getAttribute('data-bf-chips'));
      if (!raster) return;
      var leeg = raster.parentNode.querySelector('[data-bf-leeg]');

      balk.addEventListener('click', function (event) {
        var knop = event.target.closest('[data-bf-filter]');
        if (!knop) return;
        var filter = knop.getAttribute('data-bf-filter');
        balk.querySelectorAll('[data-bf-filter]').forEach(function (k) {
          k.setAttribute('aria-pressed', k === knop ? 'true' : 'false');
        });
        var zichtbaar = 0;
        raster.querySelectorAll('[data-bf-kenmerken]').forEach(function (item) {
          var kenmerken = ' ' + item.getAttribute('data-bf-kenmerken') + ' ';
          var tonen = filter === 'alle' || kenmerken.indexOf(' ' + filter + ' ') !== -1;
          item.hidden = !tonen;
          if (tonen) zichtbaar += 1;
        });
        if (leeg) leeg.hidden = zichtbaar > 0;
      });
    });
  }

  function init() {
    ruimOp();
    try {
      kiesVerkoper();
    } catch (_fout) {
      /* de eerste verkoper blijft staan */
    }
    chips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
